<template>
    <div class="customerold">
  
      <h1>Kund- och anläggningsuppgifter</h1>
      <form @submit.prevent="submit" id="customerold-propertyinfo">
        <div class="customerold__field-group">
           <label class="customerold__field-wrapper">
            <span class="customerold__field-label customerold__field-label--title">Personnummer <em>*</em></span>
            <input type="text" v-model="$root.personnummer" placeholder="ååååmmdd-xxxx" class="customerold__field required ssn">
          </label>
          <label class="customerold__field-wrapper">
            <span class="customerold__field-label">Förnamn <em>*</em></span>
            <input type="text" v-model="$root.name" class="customerold__field required" >
          </label>
          <label class="customerold__field-wrapper">
            <span class="customerold__field-label">Efternamn <em>*</em></span>
            <input type="text" v-model="$root.surname" class="customerold__field required"  >
          </label>
          <label class="customerold__field-wrapper">
            <span class="customerold__field-label">E-postadress <em>*</em></span>
  
              <email-auto-complete ref="EmailAutoComplete" :onCompletion='(val) => $root.email = val' v-bind="$root.emailAutoComplete">
                <input type="email" v-model="$root.email" class="customerold__field required" @keyup='checkEvent($event)' />
              </email-auto-complete>
          </label>
          <label class="customerold__field-wrapper">
            <span class="customerold__field-label">Telefon <em>*</em></span>
            <input type="text" v-model="$root.phone" class="customerold__field required" >
          </label>
        </div>

        <h2>Välj anläggning</h2>
        <small>Du kan endast välja en anläggning åt gången</small>
        <div class="uppgifter__field-extra">
        <li v-for="(prop, index) in props" :key="prop.id" style="display:block;">
              <label class="checkbox">
                <input type="radio" v-model="$root.possible_properties_index_choice" name="propchoice" :value="index" required class="checkbox__field">
                <span class="checkbox__label">{{prop.address}}, {{prop.postal_code}} {{prop.postal_city}} <strong>{{propText(prop)}}</strong></span>
              </label>
        </li>
        </div>
        <span class="feedback" v-bind:class="{hidden : (!$root.feedback.prop) }">{{$root.feedback.prop}}</span>
  
        <div class="step-nav">
          <button type="submit" class="button button--with-icon step-nav__button" v-on:click="$root.trackClickEvent('cta_kunduppgifter_steg6')">Fortsätt <Arrow /></button>
        </div>
      </form>
    </div>
  </template>
  <script>
  import EmailAutoComplete from "vue-email-autocomplete";
  import "vue-email-autocomplete/dist/vue-email-autocomplete.css";
  
  export default {
  
    components: {
      EmailAutoComplete
    },  
    created() {

    },
    mounted() {
        document.getElementsByClassName('customerold')[0].scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
      },
    data() {
      return {
        emailAddress: '',
        props: this.$root.possible_properties
      }
    },
    methods: {
      getNumberText(txt) {
            if (!txt)
                return '';

            let s = '';

            for (let i = 0; i < txt.length; i++) {
                let c = txt[i];

                if (c >= '0' && c <= '9') {
                    s += c;
                }
            }

            return s;
        },
      propText(prop) {

        if (prop.ean === 'new') {
          return ' (För annat postnr, ändra din sökning i steg ett)';
        }

        let propStopDate = new Date(prop.contract_stopdate);

        let isValidDate = propStopDate instanceof Date && !isNaN(propStopDate);

        if (!isValidDate || !prop.contract_stopdate || (typeof(propStopDate.getFullYear) != 'undefined' && propStopDate.getFullYear() >= 9999)) {
          return '(' + prop.contract_description + ')';
        } else {
          // {{ prop.address }} <strong>({{prop.contract_description}} med slutdatum: {{prop.contract_stopdate}})
          return '(' + prop.contract_description + ' med slutdatum: ' + prop.contract_stopdate + ')';
        }
      },
      checkEvent($event) {
        
        if ($event.target.value.indexOf('@') > 0) {
          var parts = $event.target.value.split('@');
          var domainPart = parts[1];
  
          this.$root.emailAutoComplete.domains[12] = domainPart + '.se';
        }
  
        // https://github.com/jameswylie/vue-email-autocomplete?ref=madewithvuejs.com
        this.$refs.EmailAutoComplete.check($event);
  
      },
      checkValidity(onlyUpdateIfValid) {
      
          if (!onlyUpdateIfValid)
              onlyUpdateIfValid = false;
              
          var r = true;
          
      var elements = document.querySelectorAll('.customerold INPUT');
          for (var i = 0; i < elements.length; i++) {
              var el = elements[i];
              
              el.oninput = function (e) {
                  e.target.setCustomValidity('');
              }
              
              var customCheck = true;
              var isRequired = true;
              
              if (el.className.indexOf('ssn') > 0) {
                  this.$root.feedback.ssn = false;
                  var ssnCheck = this.$root.validatePersonnummer(this.$root.personnummer);
                  
                  if (!ssnCheck) {
                      this.$root.feedback.ssn = true;
                      customCheck = false;
                  }
              } 
              
              if (el.className.indexOf('notrequired') > 0) {
                  isRequired = false;
              }
              
              if (onlyUpdateIfValid) {
                  if (el.value != '') {
                      el.setCustomValidity('');
                  }
              } else {
                  el.setCustomValidity('');
                  if (isRequired && (el.value == '' || !el.validity.valid || !customCheck)) {
                      //console.log (el);
                      el.setCustomValidity("Fyll i det här fältet.");
                      r = false;
                  }
              }
          }
          
          return r;
      },
      addFormPropWarning(txt) {
        this.$root.feedback.prop = txt;
      },
      submit() {
        if (!this.checkValidity()) {
          return false;
        }

        let foundProp = this.$root.possible_properties[this.$root.possible_properties_index_choice];

        if (!foundProp) {
          this.addFormPropWarning('Ingen anläggning vald.');
          return false;
        }

        if (foundProp.ean === 'new') {
          this.$root.detailsShow = 'customernew';
          //this.$root.flowString += 'customerold';
          this.$root.customer = 'old_with_new_property';

          this.$root.territory_id = '';
          this.$root.construction_id = '735 999';
          this.$root.address = '';
          this.$root.postal_code = this.$root.searchPostalCode;
          this.$root.location = '';
          this.$root.old_contract_description = '';

          this.$root.invoice_address_same_as_property = false;

          return true;
        }

        let propStopDate = new Date(foundProp.contract_stopdate);

        if (propStopDate.getFullYear() < 9999) {

          if (this.$root.searchStartDate < foundProp.contract_stopdate) {
            this.addFormPropWarning('Du har ett bundet avtal till ' + foundProp.contract_stopdate + ' och kan inte teckna ett nytt avtal innan det avtalet löpt ut.');
            return false;
          }

        }

        if (this.getNumberText(foundProp.postal_code) != this.getNumberText(this.$root.searchPostalCode)) {
          alert ("Postnumret som kommer upp för denna anläggning (" + foundProp.postal_code + ") skiljer sig ifrån vad som är ifyllt ovan. Var god ändra din sökning i steg ett för att gå vidare.");
          return false;
        }
        

        this.$root.territory_id = foundProp.net_areacode;
        this.$root.construction_id = foundProp.ean;
        this.$root.address = foundProp.address;
        this.$root.postal_code = foundProp.postal_code;
        this.$root.location = foundProp.postal_city;
        this.$root.old_contract_description = foundProp.contract_description;
              
        //this.$router.push({ name: 'ordersummary' })
        //this.$root.detailsShow = 'ordersummary';
        
        this.$root.detailsShow = 'newstartdate';

        this.$root.flowString += 'customerold';
      },
      provider() {
          if(!this.$root.providing_cunstruction_and_territory_id) {
              this.$root.not_providing_cunstruction_and_territory_id = false;
          }else{
              this.$root.providing_cunstruction_and_territory_id = false;
          }
      },
      lookup() {
          var ssn = this.$root.validatePersonnummer(this.$root.personnummer);
          var nonce = this.$root.getCookie('elavtal');
          if(ssn) {
              this.$root.feedback.ssn = false; // hide feedback for ssn
              this.$root.loading = true;
              const headers = new Headers();
              headers.append(
                  "Authorization",
                  nonce
              );
              //this.$root.publicUrl + '/api/
              //fetch('https://api.energiinfo.se/PersonInfo/boraselhandel/?AuthenticationKey=da717382c7874d43bf6c8eb22a9a9a90&nomask=b88be4ea20734b3181f7633026421a3c&logkey=boraselhandelorderpage&ssn='+this.$root.personnummer).then(r => r.json()).then(r => {
              
              var curThis = this;
              
              fetch(this.$root.publicUrl + '/api/person.php?ssn='+this.$root.personnummer, {
                  method: "GET",
                  headers,
                  cache: "default"
              }).then(r => r.json()).then(r => {
                  this.$root.loading = false;
                  if(r.status==='OK'){
                      this.$root.name = r.data.givenName;
                      this.$root.surname = r.data.lastName;
                      this.$root.address = r.data.street;
                      this.$root.location = r.data.city;
                      this.$root.postal_code = r.data.zipCode;
                      
                      setTimeout (function () {
                          curThis.checkValidity(true);
                      }, 100);
                  }else{
                      console.log(r);
                      alert('Det gick ej att hämta uppgifter. Var god fyll i för hand.')
                  }
              });
          }
      },
    }
  }
  </script>
  <style lang="scss">
    .uppgifter__anlaggning {
      margin-top: 35px;
      &__hidden {
        padding-top: 20px;
      }
      h3 {
        font-size: 18px;
      }
      &__subtitle {
        display: block;
        font-size: 18px;
        font-weight: bold;
      }
      &__field-wrapper {
        position: relative;
        display: block;
        margin-bottom: rem(16);
      }
      &__field-wrapper .info-circle {
        position: absolute;
        top: 60%;
        right: 5%;      
      }    
      &__field {
        position: absolute;
        opacity: 0;
      }
      &__field-content {
        border: 1px solid $light-border-color;
        border-radius: 3px;
        display: block;
      }
      &__field:focus + &__field-content,
      &__field-content:hover {
        border-color: $dark-border-color;
      }
      &__field:checked + &__field-content {
        border-color: $primary-color;
        border-width: 2px;
      }
      &__field-label {
        display: block;
        @include font-primary;
        font-size: rem(16);
        padding: rem(19);
        position: relative;
        em {
          font-style: normal;
          color: #c00;
        }
      }
      .info-circle {
        position: absolute;
        right: 15px;
        bottom: 7px;
        .tooltip {
          display: none;
        }
        &:hover .tooltip {
          display: block;
          left: -360px;
        }
      }
    }
    .customerold {
      &__title {
        text-align: center;
        margin: 0 0 rem(30);
        @include font-primary;
        @include media('>lg') {
          font-size: rem(26);
        }
        @include media('<=lg') {
          font-size: rem(22);
          line-height: (36/22);
        }
      }
      &__block {
        margin-bottom: rem(40);
      }
      &__block-title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        margin: 0 0 rem(15);
      }
      &__field-wrapper {
        margin-bottom: rem(24);
        font-size: rem(16);
        display: block;
        position: relative;
      }
  
      &__field-group {
        @include media('>lg') {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
        }
      }
      &__lookup {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: flex-end;
          .feedback {
              margin-top: -15px;
              margin-bottom: 20px;
          }
      }
      &__field-group &__field-wrapper {
        @include media('>lg') {
          flex-basis: calc(50% - #{rem(12)});
        }
      }
      &__lookup &__field-wrapper {
        flex-basis: calc(50% - #{rem(12)});
      }
      &__field {
        @include unstyled-text-field;
        display: block;
        width: 100%;
        border: 1px solid $light-border-color;
        padding: #{(13/18)}em;
        &:focus,
        &:hover {
          border-color: $dark-border-color;
        }
        &::placeholder {
          color: $dark-border-color;
        }
      }
      &__field-label {
        @include font-primary;
        color: $secondary-text-color;
        margin: 0 0 rem(6);
        display: block;
        &--title {
          @include font-primary(bold);
          color: $secondary-text-color;
          font-size: rem(18);
          display: block;
          margin: 0 0 rem(9);
        }
        em {
          font-style: normal;
          color: #c00;
        }
      }
      &__lookup-submit {
        @include media('>lg') {
          flex: 1 1;
          margin: 0 0 rem(24) rem(24);
        }
        @include media('<=lg') {
          /*flex: 1 1;*/
          margin: 0 0 rem(24) 0;
        }
        font-size: rem(16);
        &[disabled], &:hover[disabled]{
          background-color: #fff;
        }
        .customerold__submit_text {
          display: block;
        }
        .customerold__submit_loader {
          display: none;
        }
        &.loading {
          padding: 9px 0 6px 0;
          .customerold__submit_text {
            display: none;
          }
          .customerold__submit_loader {
            display: block;
          }
        }
      }
      &__ids {
        margin-bottom: 1rem;
      }
      &__ids-text {
        @include font-primary(roman);
        font-size: rem(13);
        padding: rem(16);
        background-color: $light-bg-color;
        color: $secondary-text-color;
        text-align: center;
        border-radius: 4px;
        display: block;
        width: 100%;
        margin: 25px 0 10px 0;
      }
    }

  .uppgifter {
    &__title {
      text-align: center;
      margin: 0 0 rem(30);
      @include font-primary;
      @include media('>lg') {
        font-size: rem(26);
      }
      @include media('<=lg') {
        font-size: rem(22);
        line-height: (36/22);
      }
    }
    &__block {
      margin-bottom: rem(40);
    }
    &__block-title {
      @include font-primary(bold);
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      font-size: rem(18);
    }
    &__block-subtitle {
      @include font-primary(roman);
      margin: 0;
      margin: 0 0 rem(16);
      font-size: rem(16);
    }
    &__field-wrapper {
      position: relative;
      display: block;
      margin-bottom: rem(16);
    }
    &__field {
      position: absolute;
      opacity: 0;
    }
    &__field-content {
      border: 1px solid $light-border-color;
      border-radius: 3px;
      display: block;
    }
    &__field:focus + &__field-content,
    &__field-content:hover {
      border-color: $dark-border-color;
    }
    &__field:checked + &__field-content {
      border-color: $primary-color;
      border-width: 2px;
    }
    &__field-label {
      display: block;
      @include font-primary;
      font-size: rem(18);
      padding: rem(19);
    }
    .info-circle {
      font-size: rem(16);
      padding-top: 2px;
      margin-bottom: -2px;
      position: absolute;
      margin-left: 8px;
    }
    &__field-label-info {
      font-size: rem(16);
      float: right;
    }
    &__field:checked + &__field-content &__field-label {
      @include font-primary(bold);
    }
    &__field-wrapper--asap-false &__field-content {
      display: flex;
      align-items: center;
    }
    &__field-wrapper--asap-false &__field-label {
      flex: 1 1;
    }
    &__field-wrapper--asap-false &__field-extra {
      position: relative;
      z-index: 1;
      right: rem(16);
    }
    &__calendar-wrapper {
      display: inline-block;
    }
    &__calendar#{&}__calendar { // double class to have more specificity than default styles
      right: 0;
      top: 0;
      padding: 1em;
      border: 0;
      box-shadow: 0 0 8px 3px rgba(0, 0, 0, 0.06);
      color: $secondary-text-color;
      header {
        @include font-primary(bold);
        font-size: 1em;
      }
      .cell {
        &.day {
          @include font-primary(roman);
          position: relative;
          z-index: 1;
          font-size: ((13/18) * 1em);
          border: 1px solid;
          margin: -1px 0 0 -1px;
          width: calc((100% / 7) + 1px);
          &.blank {
            border-color: transparent;
          }
          &:not(.disabled):not(.blank):hover {
            border-color: $primary-color;
            z-index: 2;
          }
        }
        &.selected {
          background-color: $primary-color;
          border-color: $primary-color;
          color: #fff;
          z-index: 2;
        }
        &.disabled {
          color: $light-border-color;
        }
        &.day-header {
          font-size: ((11/18) * 1em);
        }
      }
    }
    &__calendar-action {
      display: inline-block;
      line-height: 1;
      svg {
        display: inline-block;
        width: 1.2rem;
        height: 1.2rem;
        margin-left: 0.6rem;
        vertical-align: -0.2rem;
      }
    }
    &__date-field {
      opacity: 0;
      position: absolute;
      right: 0;
    }
    &__price-monitor-title {
      @include font-primary(bold);
      font-size: rem(16);
      margin: 0;
      color: $secondary-text-color;
    }
    &__field-wrapper--price-monitor &__field-extra {
      padding: 0 rem(19) rem(19);
    }
  }
  

  .uppgifterText {
    &__field-wrapper {
      margin-bottom: rem(24);
      font-size: rem(16);
      display: block;
      position: relative;
    }
    &__field-group &__field-wrapper {
      @include media('>lg') {
        flex-basis: calc(50% - #{rem(12)});
      }
    }
    &__field {
      @include unstyled-text-field;
      display: block;
      width: 100%;
      border: 1px solid $light-border-color;
      padding: #{(13/18)}em;
      &:focus,
      &:hover {
        border-color: $dark-border-color;
      }
      &::placeholder {
        color: $dark-border-color;
      }
    }
    &__field-label {
      @include font-primary;
      color: $secondary-text-color;
      margin: 0 0 rem(6);
      display: block;
      &--title {
        @include font-primary(bold);
        color: $secondary-text-color;
        font-size: rem(18);
        display: block;
        margin: 0 0 rem(9);
      }
      em {
        font-style: normal;
        color: #c00;
      }
    }
	
	&__field_placeholder_style::-webkit-input-placeholder {
		font-style: italic;
	}
	&__field_placeholder_style:-moz-placeholder {
		font-style: italic;  
	}
	&__field_placeholder_style::-moz-placeholder {
		font-style: italic;  
	}
	&__field_placeholder_style:-ms-input-placeholder {  
		font-style: italic; 
	}
    &__feedback {
		margin-top: -15px;
		margin-bottom: 20px;
	}

  }
</style>
